import { render, staticRenderFns } from "./BasicModal.vue?vue&type=template&id=0438947a&scoped=true"
import script from "./BasicModal.vue?vue&type=script&lang=js"
export * from "./BasicModal.vue?vue&type=script&lang=js"
import style0 from "./BasicModal.scss?vue&type=style&index=0&id=0438947a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0438947a",
  null
  
)

export default component.exports